module.exports = __webpack_public_path__ + "img/shoulder_width.e270a8ba.png";